// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.documents.LeaseDocumentsOuidWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  GetExplainerLeaseForLeaseFromOuidResponseDto,
  GetLandlordProvidedDocumentsFromOuidResponseDto,
  PreviewUrlFromOuidResponseDto,
} from '../..';

interface GetExplainerLeaseFromOuidParams {
  ouid: string;
}
interface GetLandlordProvidedDocumentsFromOuidParams {
  ouid: string;
}
interface PreviewUrlFromOuidParams {
  ouid: string;
}

export const LeaseDocumentsOuidWebApiHandler_getExplainerLeaseFromOuid_Path =
  '/api/web/v1/ouid/getExplainerLeaseFromOuid';

/**
 * get explainer lease file name associated with specific lease from ouid token
 */
export const LeaseDocumentsOuidWebApiHandler_getExplainerLeaseFromOuid = (
  getParams: GetExplainerLeaseFromOuidParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetExplainerLeaseFromOuidParams, never, GetExplainerLeaseForLeaseFromOuidResponseDto>(
    {
      getParams: getParams,
      endpoint: LeaseDocumentsOuidWebApiHandler_getExplainerLeaseFromOuid_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};

export const LeaseDocumentsOuidWebApiHandler_getLandlordProvidedDocumentsFromOuid_Path =
  '/api/web/v1/ouid/getLandlordProvidedDocumentsFromOuid';

/**
 * get landlord provided document names from ouid token
 */
export const LeaseDocumentsOuidWebApiHandler_getLandlordProvidedDocumentsFromOuid = (
  getParams: GetLandlordProvidedDocumentsFromOuidParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    GetLandlordProvidedDocumentsFromOuidParams,
    never,
    GetLandlordProvidedDocumentsFromOuidResponseDto
  >(
    {
      getParams: getParams,
      endpoint: LeaseDocumentsOuidWebApiHandler_getLandlordProvidedDocumentsFromOuid_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};

export const LeaseDocumentsOuidWebApiHandler_previewUrlFromOuid_Path = '/api/web/v1/ouid/previewUrlFromOuid';

/**
 * get preview lease url from ouid token
 */
export const LeaseDocumentsOuidWebApiHandler_previewUrlFromOuid = (
  getParams: PreviewUrlFromOuidParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<PreviewUrlFromOuidParams, never, PreviewUrlFromOuidResponseDto>(
    {
      getParams: getParams,
      endpoint: LeaseDocumentsOuidWebApiHandler_previewUrlFromOuid_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};
